<template>
  <div class="hd_bar">
    <div class="hd_ic ic-career"></div>
    <div class="hd_txt">
      <v-clamp class="title_txt" autoresize :max-lines="2" id="careerTitle">{{ career.name }}</v-clamp>
    </div>

    <template v-if="career && career.uuid && !isTempUser && isBookmarkEnabled">
      <span v-if="isBookmarked(career)" @click.stop.prevent="deleteCareerBookmark(career)" class="ic_bm_container bookmarked hd_txt" title="remove this career from bookmark">
        <span class="ic8-bookmark3"></span>
      </span>
      <span v-else @click.stop.prevent="bookmarkCareer(career)" class="ic_bm_container hd_txt" title="bookmark this career">
        <span class="ic8-bookmark3"></span>
      </span>
    </template>

    <b-popover ref="careerTitlePopup" target="careerTitle" triggers="click" placement="top" class="title_popup" container="careerNameContainer">
      <div class="title_container">
        {{ career.name }}
      </div>
      <div class="ic_container">
        <span class="ic ic-close" v-on:click="closeCareerTitlePopup"></span>
      </div>
    </b-popover>
    <div id="careerNameContainer" class="title_container_popup"></div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'career-title',
    props: ['career'],
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'isTempUser': state => state.login.tempUser,
        'bookmarks': state => state.explore.bookmarks
      })
    },
    async mounted () {
      await this.loadAllBookmarks()
    },
    methods: {
      ...mapActions([
        'loadAllBookmarks',
        'loadCreateBookmarks',
        'loadDeleteBookmark'
      ]),
      closeCareerTitlePopup () {
        this.$refs.careerTitlePopup.$emit('close')
      },
      getBookmark (career) {
        let target = _.find(this.bookmarks, (bookmark) => {
          return (bookmark.entityUuid === career.uuid)
        })
        return target
      },
      isBookmarked (career) {
        career.bookmark = this.getBookmark(career)
        return career.bookmark && career.bookmark.uuid
      },
      async bookmarkCareer (career) {
        const bookmark = {
          source: 'explore',
          entityType: 'career',
          entityTitle: career.name,
          entityUuid: career.uuid,
          userId: this.userObj.uuid
        }
        const response = await this.loadCreateBookmarks(bookmark)
        const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
        const notify = response ? this.notifySuccess : this.notifyFailure
        notify(message)
        await this.loadAllBookmarks()
      },
      async deleteCareerBookmark (career) {
        await this.loadDeleteBookmark(career.bookmark.uuid)
        this.notifySuccess('Successfully deleted bookmark \'' + career.name + '\'')
        await this.loadAllBookmarks()
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/career/components/CareerTitle.vue